import useAppState from "../../context/AppContext";
import { useLocation } from "react-router-dom";


export default function NavbarBloc() {
  const {
    state: {proposition, infoSteps },
  } = useAppState();

  const currentLocation = useLocation();

  const getState = (step: number) => {
    const currentCategory = infoSteps.find(step => step.path === currentLocation.pathname)?.category;
    let currentIndex = 0;
    if (currentCategory === "PERSONAL") {
      currentIndex = 1;
    } else if (currentCategory === "BENEFICIARY") {
      currentIndex = 2;
    } else if (currentCategory === "GUARANTY") {
      currentIndex = 3;
    } else if (currentCategory === "SIGNATURE") {
      currentIndex = 4;
    }
    if (step === currentIndex) {
      const steps = infoSteps.filter(s => s.category === currentCategory);
      const index = steps.findIndex(s => s.path === currentLocation.pathname);
      const barStyle = steps.length > 0 ? {width : `${Math.ceil(index/steps.length) *100}%`} : {};
      return {state :"active", style: barStyle};
    } else if (step > currentIndex) {
      return {state: "incomplete", style: {}};
    } else {
      return {state : "completed", style: {}};
    }
  }; 

  return (
    <div className="navbar-container ta-center">
        <div className="" style={{width: '25%'}}>
          <div className=""><img src={process.env.REACT_APP_RESSOURCE_BASE_URL + `${getState(1).state === "completed" ? "/img/Picto_affilie_R.svg" : "/img/Picto_affilie_B.svg"}`} width="50" height="50" style={{boxShadow: "none"}} alt=""/></div>
          <div className="fz-sm">Je m'affilie</div>
        </div>
        
        {proposition?.configuration?.canBeAddedBeneficiaries &&
          <div className="" style={{width: '25%'}}>
            <div className=""><img src={process.env.REACT_APP_RESSOURCE_BASE_URL + `${getState(2).state === "completed" ? "/img/Picto_proches_R.svg" : "/img/Picto_proches_B.svg"}`} width="50" height="50" style={{boxShadow: "none"}} alt=""/></div>
            <div className="fz-sm">Je couvre mes proches</div>
          </div>
        }

        {proposition?.configuration?.hasOfferStep &&
          <div className="" style={{width: '25%'}}>
            <div className=""><img src={process.env.REACT_APP_RESSOURCE_BASE_URL + `${getState(3).state === "completed" ? "/img/Picto_couverture_R.svg" : "/img/Picto_couverture_B.svg"}`} width="50" height="50" style={{boxShadow: "none"}} alt=""/></div>
            <div className="fz-sm">Je renforce ma couverture</div>
          </div>
        }
        
        <div className="" style={{width: '25%'}}>
          <div className=""><img src={process.env.REACT_APP_RESSOURCE_BASE_URL + `${getState(4).state === "completed" ? "/img/Picto_finalise_R.svg" : "/img/Picto_finalise_B.svg"}`} width="50" height="50" style={{boxShadow: "none"}} alt=""/></div>
          <div className="fz-sm">Je finalise</div>
        </div>  
    </div>
  )
}
